import { Mock } from '@interfaces/mock.interface';

export const EdpWarningMock: Mock = {
    key: 'edp-warning',
    label: 'Edp Warning',
    default: true,
    method: 'GET',
    data: {
        idPanier: '200210763',
        parcours: [
            {
                idParcours: '18546',
                produits: [
                    {
                        idProduit: '58331',
                        gencode: '6901443179664',
                        modesDeFinancementPanier: ['COMPTANT'],
                        modesDeFinancementProduits: [],
                    },
                    {
                        idProduit: '58333',
                        gencode: '3526356054230',
                        modesDeFinancementPanier: ['COMPTANT'],
                        modesDeFinancementProduits: [],
                    },
                    {
                        idProduit: '58335',
                        gencode: 'LIVRAISON_DIRECTE',
                        modesDeFinancementPanier: ['COMPTANT'],
                        modesDeFinancementProduits: [],
                    },
                ],
            },
        ],
        modesDeFinancement: [
            {
                libelle: 'Comptant',
                modesDePaiement: [
                    {
                        type: 'CB',
                    },
                ],
                propositionsCommerciales: [
                    {
                        apportInitial: 5.9,
                        montantReelAbsolu: 5.9,
                        coutTotalFinancement: 5.9,
                        montantAFinancer: 5.9,
                        montantInterets: 0,
                        montantMensualite: 0,
                        nbrEcheances: 0,
                        dateFinancement: '2022-07-05T20:12:04.496Z',
                        premiereDateMensualite: '2022-07-05T20:12:04.496Z',
                        dernierMontantMensualite: 0,
                        tAEG: 0,
                    },
                ],
                type: 'COMPTANT',
            },
        ],
    },
};
